var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlertErrorRed(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0007 22.2229V10.0007M20.069 27.9173C19.9032 27.9173 19.7443 27.8515 19.6271 27.7343C19.5099 27.617 19.444 27.4581 19.444 27.2923C19.444 27.1266 19.5099 26.9676 19.6271 26.8504C19.7443 26.7332 19.9032 26.6673 20.069 26.6673C20.2348 26.6673 20.3937 26.7332 20.511 26.8504C20.6282 26.9676 20.694 27.1266 20.694 27.2923C20.694 27.4581 20.6282 27.617 20.511 27.7343C20.3937 27.8515 20.2348 27.9173 20.069 27.9173ZM20.0007 36.6673C29.2051 36.6673 36.6673 29.2051 36.6673 20.0007C36.6673 10.7962 29.2051 3.33398 20.0007 3.33398C10.7962 3.33398 3.33398 10.7962 3.33398 20.0007C3.33398 29.2051 10.7962 36.6673 20.0007 36.6673Z",
    stroke: "#C12010",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertErrorRed);
export default __webpack_public_path__ + "static/media/alert-error-red.ac5d4237b6b9a132199f66b4aa8bd27d.svg";
export { ForwardRef as ReactComponent };